<template>
    <div id="persian-calendar">
      <!--CALENDAR HEADER-->
      <div id="vpc_header">
        <div id="vpc_date-control">
          <div class="vpc_control-btn" @click="subtractPeriod" :disabled="isBeforeMin()">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
          </div>

          <span v-if="isWeekPeriod" class="vpc_now-date">
              {{displayRangeText}}
          </span>
          <span v-else class="vpc_now-date">{{currentDate.format('jMMMM jYYYY')}}</span>

          <div class="vpc_control-btn" @click="addPeriod" :disabled="isAfterMax()">
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
          </div>
          <div v-if="!disableToday" class="vpc_today-btn" @click="goToday" :disabled="todayBtnDisable">امروز</div>
        </div>
          <div v-if="!disablePeriod" class="vpc_period-control">
              <div class="vpc_period-btn" @click="togglePeriod">{{displayPeriodText}}</div>
          </div>
      </div>
      <!--CALENDAR GRID-->
      <transition :name="transitionAction" @after-leave="currentDateChange = true">
        <div v-if="currentDateChange">
          <div id="vpc_calendar" :style="{border: isWeekPeriod ? '1px solid #ddd' : 'unset'}">
            <!-- <div class="vpc_week-overlay"></div> -->

            <!--DAYS HEADER-->
            <div id="vpc_days-header">
              <div>شنبه</div>
              <div>یکشنبه</div>
              <div>دوشنبه</div>
              <div>سه شنبه</div>
              <div>چهار شنبه</div>
              <div>پنج شنبه</div>
              <div>جمعه</div>
            </div>
            <!--WEEKS ROW-->
            <div v-for="(week, weekIndex) in periodWeeks" :key="week.uid" :class="weekClassObject">
                <template v-for="i in getWeekEvents(week[0].startOf('week')).filter(x => isWeekPeriod ? true : x.eventRow <= 7)" :key="i.id">
                      <div :class="i.classes" :style="`top:${getEventTop(i)}`" class="vpc_event cursor-pointer">
                          <!-- @click="$refs.addOrEdit.openAsEdit(i)" -->
                          <div v-if="isWeekPeriod" @click="$refs.showDetails.open(i)" :style="{backgroundColor: i.color}" class="vpc_event-inner">
                              <span class="vpc_event-start-time" v-if="!hideEventTimes">
                                  <span v-if="i && Object.hasOwn(i, 'end_date')">{{ i.end_date.format('HH:mm') }} - </span>{{ i.start_date.format('HH:mm') }}
                              </span>
                              <!-- <div :style="{'background-color':i.color}" class="vpc_event-ball"></div> -->
                              <!-- <span class="vpc_event-start-date" v-if="!hideEventTimes">{{ i.start_date.format('jMM/jDD') }}</span> -->
                              <span class="vpc_event-title">{{ i.title }}</span>
                              <!-- <span class="vpc_event-end-time" v-if="!hideEventTimes && Object.hasOwn(i, 'end_date')">{{ i.end_date.format('HH:mm') }}</span> -->
                              <!-- <span class="vpc_event-end-date" v-if="!hideEventTimes && Object.hasOwn(i, 'end_date')">{{ i.end_date.format('jMM/jDD') }}</span> -->
                          </div>
                          <div v-else-if="i.eventRow <= 6" @click="$refs.showDetails.open(i)" class="vpc_event-inner">
                              <div :style="{'background-color':i.color}" class="vpc_event-ball"></div>
                              <div v-if="!hideEventTimes">{{ i.start_date.format('HH:mm') }}</div>
                              <div class="vpc_event-title">{{ i.title }}</div>
                          </div>
                          <div v-else-if="i.eventRow == 7" class="vpc_event-inner" style="margin-right: 3px;" @click="showAllEventsInDay(i)">و {{ getWeekEvents(week[0].startOf('week')).filter(x => x.classes.includes(i.classes.find(x => x.includes('offset')))).filter(Boolean).length - 7 }} مورد دیگر</div>
                      </div>
                </template>
              <!--DAYS-->
              <div
                  v-for="(day,index) in week"
                  :key="day.uid"
                  :class="dayClassObject(day)"
                  @click="$refs.addOrEdit.openAsNew(day)"
                  @mouseover="()=>{isWeekPeriod ? canAddEvent[index] = true : canAddEventMonth[index + (weekIndex * 7)] = true}"
                  @mouseout="()=>{isWeekPeriod ? canAddEvent[index] = false : canAddEventMonth[index + (weekIndex * 7)] = false}"
              >
                <h3 v-if="isWeekPeriod && canAddEvent[index]" class="text-center d-block cursor-pointer">&plus;</h3>
                <h3 v-else-if="!isWeekPeriod && canAddEventMonth[index + (weekIndex * 7)]" class="cursor-pointer">&plus;</h3>
                <div v-else class="vpc_day-number">{{ day.format('jD') }}</div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <add-or-edit
        ref="addOrEdit"
        @complete="(data, editId = false)=>{$emit('addOrEditIsReady', data, editId)}"
      ></add-or-edit>
      <show-details
        @edit="(item)=>{$refs.addOrEdit.openAsEdit(item)}"
        @delete="(item)=>{$emit('delete', item)}"
        ref="showDetails"
      ></show-details>
      <show-all-events-in-day
        ref="showAllEventsInDay"
        @openEvent="(item)=>{$refs.showDetails.open(item)}"
      ></show-all-events-in-day>
    </div>
</template>

<script>
import moment from "moment-jalaali";
export default {
    props: {
        dateFormat: {
            type: String,
            default() {
                return "jYYYY/jMM/jDD";
            },
        },
        displayPeriod: String,
        eventsList: {
            type: Array,
            default() {
                return [];
            },
        },
        minDate: [Object, String],
        maxDate: [Object, String],
        hideEventTimes: {
            type: Boolean,
            default() {
                return false;
            },
        },
        disableToday: {
            type: Boolean,
            default() {
                return false;
            },
        },
        disablePeriod: {
            type: Boolean,
            default() {
                return false;
            },
        },
        hideMonthShadow: {
            type: Boolean,
            default() {
                return false;
            },
        },
        hidePastDaysShadow: {
            type: Boolean,
            default() {
                return false;
            },
        },
        disablePastDays: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    data() {
        return {
            currentDate: null,
            currentDateChange: true,
            transitionAction: "slide-right",
            addEventModalShow: false,
            period: "month",
            events: [],
            min: null,
            max: null,
            showDate: moment(new Date()).format('jYYYY/jMM/jDD'),
            //ME
            canAddEvent: {0:false,1:false,2:false,3:false,4:false,5:false,6:false},
            canAddEventMonth: {0:false,1:false,2:false,3:false,4:false,5:false,6:false,7:false,8:false,9:false,10:false,11:false,12:false,13:false,14:false,15:false,16:false,17:false,18:false,19:false,20:false,21:false,22:false,23:false,24:false,25:false,26:false,27:false,28:false,29:false,30:false,31:false,32:false,33:false,34:false,35:false,36:false,37:false,38:false,39:false,40:false},
        };
    },
    computed: {
        month() {
            return this.currentDate.format("jM");
        },
        year() {
            return this.currentDate.format("jYYYY");
        },
        daysInMonth() {
            // Generating all days in current month
            const days = [];
            let currentDay = moment(`${this.year}-${this.month}-1`, "jYYYY-jM-jD");
            do {
                days.push(currentDay);
                currentDay = moment(currentDay).add(1, "days");
            } while (moment(currentDay).format("jM") === this.month);
            // Add previous days to start
            currentDay = moment(days[0]);
            const SHANBE = 6;
            const JOMEE = 5;
            if (currentDay.day() !== SHANBE) {
                do {
                    currentDay = moment(currentDay).subtract(1, "days");
                    days.unshift(currentDay);
                } while (currentDay.day() !== SHANBE);
            }
            // Add following days to end
            currentDay = moment(days[days.length - 1]);
            if (currentDay.day() !== JOMEE) {
                do {
                    currentDay = moment(currentDay).add(1, "days");
                    days.push(currentDay);
                } while (currentDay.day() !== JOMEE);
            }
            return days;
        },
        daysInWeek() {
            const days = [];
            const showDay = this.currentDate;
            let day = showDay.startOf("week");
            do {
                days.push(day);
                day = moment(day).add(1, "days");
            } while (!day.isSame(moment(showDay).add(7, "days")));
            return days;
        },
        weeksInMonth() {
            const weeks = [];
            let week = [];
            for (let i = 0; i < this.daysInMonth.length; i++) {
                week.push(this.daysInMonth[i]);
                if (week.length === 7) {
                    weeks.push(week);
                    week = [];
                }
            }
            return weeks;
        },
        isWeekPeriod() {
            return this.period === "week";
        },
        periodWeeks() {
            return this.isWeekPeriod ? [this.daysInWeek] : this.weeksInMonth;
        },
        displayPeriodText() {
            return this.isWeekPeriod ? "ماه" : "هفته";
        },
        displayRangeText() {
            const start = moment(this.currentDate).startOf("week");
            const end = moment(start).add(6, "days");
            let startformat = "jDD";
            if (!start.isSame(end, "month")) startformat = "jDD jMMMM";
            if (!start.isSame(end, "year")) startformat = "jDD jMMMM jYYYY";

            return `${start.format(startformat)} - ${end.format("jDD jMMMM jYYYY")}`;
        },
        todayBtnDisable() {
            if (this.min) {
                if (this.max)
                    return !moment().isBetween(
                        moment(this.min).startOf("day"),
                        moment(this.max).endOf("day")
                    );
                return this.min.isAfter(moment().startOf("day"), "day");
            }
            if (this.max)
                return this.max.isBefore(moment().endOf("day"), "day");
            return this.currentDate.isSame(
                moment(),
                this.isWeekPeriod ? "Weeks" : "months"
            );
        },
        weekClassObject() {
            return {
                vpc_week: true,
                "vpc_week-period": this.isWeekPeriod,
                "vpc_month-period": !this.isWeekPeriod,
            };
        },
    },
    watch: {
        currentDate() {
            // update transition
            this.currentDateChange = false;
        },
        showDate(value) {
            this.currentDate = this.getDateByFormat(value);
        },
        displayPeriod(value) {
            this.period = value;
        },
        eventsList(value) {
            this.events = value;
        },
        minDate(value) {
            this.min = this.getDateByFormat(value);
        },
        maxDate(value) {
            this.max = this.getDateByFormat(value);
        },
    },

    created() {
        this.currentDate = this.getDateByFormat(this.showDate);
        if (this.minDate) this.min = this.getDateByFormat(this.minDate);
        if (this.maxDate) this.max = this.getDateByFormat(this.maxDate);
        this.period = this.displayPeriod;
        this.events = this.eventsList;
    },

    methods: {
        showAllEventsInDay(item){
            this.$refs.showAllEventsInDay.open(this.findAndSortEventsInDateRange(moment(item.start_date.toISOString()).startOf('day'), moment(item.start_date.toISOString()).endOf('day')));
        },
        getDateByFormat(value) {
            if (typeof value === "string")
                return moment(value, this.dateFormat);
            else if (typeof value === "object") return moment(value);
        },
        isAfterMax() {
            if (!this.max) return;
            const newDate = moment(this.currentDate).add(
                1,
                this.isWeekPeriod ? "weeks" : "months"
            );
            const periodStart = newDate.startOf(
                this.isWeekPeriod ? "week" : "jMonth"
            );
            return this.max.isValid() && periodStart.isAfter(this.max);
        },
        isBeforeMin() {
            if (!this.min) return;
            const newDate = moment(this.currentDate).subtract(
                1,
                this.isWeekPeriod ? "weeks" : "months"
            );
            const periodEnd = moment(this.min).startOf(
                this.isWeekPeriod ? "week" : "jMonth"
            );
            return this.min.isValid() && periodEnd.isAfter(newDate);
        },
        addPeriod() {
            if (this.isAfterMax()) return;
            this.transitionAction = "slide-left";
            this.currentDate = moment(this.currentDate).add(
                1,
                this.isWeekPeriod ? "weeks" : "months"
            );
            this.$emit("on-page-add", this.currentDate);
        },
        subtractPeriod() {
            if (this.isBeforeMin()) return;
            this.transitionAction = "slide-right";
            this.currentDate = moment(this.currentDate).subtract(
                1,
                this.isWeekPeriod ? "weeks" : "months"
            );
            this.$emit("on-page-subtract", this.currentDate);
        },
        goToday() {
            if (this.todayBtnDisable) return;
            if (
                this.currentDate.isBefore(moment(), "month") ||
                (this.isWeekPeriod &&
                    this.currentDate.isBefore(moment().startOf("week")))
            ) {
                this.transitionAction = "slide-left";
                this.currentDate = moment();
            } else if (
                this.currentDate.isAfter(moment(), "month") ||
                (this.isWeekPeriod &&
                    this.currentDate.isAfter(moment(), "week"))
            ) {
                this.transitionAction = "slide-right";
                this.currentDate = moment();
            }
        },
        togglePeriod() {
            this.period = this.isWeekPeriod ? "month" : "week";
            this.$emit("update:displayPeriod", this.period);
            this.$emit("on-display-period-change", this.period);

            // update transition
            this.currentDateChange = false;
        },
        dayClassObject(day) {
            const today = day.isSame(moment(), "day");

            let disable = false;
            if (this.min) {
                disable = (this.min.isValid() && day.isBefore(this.min, "day")) || disable;
            }
            if (this.max) {
                disable = (this.max.isValid() && day.isAfter(this.max, "day")) || disable;
            }

            return {
                vpc_day: true,
                vpc_today: today && !this.disableToday,
                vpc_past:
                    day.isSameOrBefore(moment(), "day") &&
                    !today &&
                    !this.hidePastDaysShadow,
                "vpc_not-current-month":
                    !day.isSame(this.currentDate, "month") &&
                    !this.isWeekPeriod &&
                    !this.hideMonthShadow,
                "vpc_week-period-day": this.isWeekPeriod,
                "vpc_day-disable": disable,
                "vpc_month": !this.isWeekPeriod
            };
        },
        eventComparer(a, b) {
            if (a.start_date.isBefore(b.start_date)) return -1;
            if (b.start_date.isBefore(a.start_date)) return 1;
            //*change for endTime
            // if (a.end_date.isAfter(b.end_date)) return -1;
            // if (b.end_date.isAfter(a.end_date)) return 1;
            return a.id < b.id ? -1 : 1;
        },
        findAndSortEventsInWeek(weekStart) {
            // Return a list of events that INCLUDE any portion of a given week.
            return this.findAndSortEventsInDateRange(
                weekStart,
                moment(weekStart).hours(23).minutes(59).seconds(59).add(6, "days")
            );
        },
        findAndSortEventsInDateRange(start_date, end_date) {
            // Return a list of events that INCLUDE any day within the date range,
            // inclusive, sorted so events that start earlier are returned first.
            return this.events.filter(
                    // (event) => event.end_date >= start_date && this.dateOnly(event.start_date) <= end_date,
                    (event) =>
                        //*change for endTime
                        // event.end_date.isSameOrAfter(start_date) && event.start_date.isSameOrBefore(end_date),
                        event.start_date.isSameOrAfter(start_date) && event.start_date.isSameOrBefore(end_date),
                    this
                ).sort(this.eventComparer);
        },
        dayHasEvents(day) {
            return this.events.find(d => d.end_date.isSameOrAfter(day) && d.start_date.isSameOrBefore(day));
        },
        // dayEvents(day) {
        //     return this.events.filter((d) => d.end_date.isSameOrAfter(day) && d.start_date.isSameOrBefore(day)).sort(this.eventComparer);
        // },
        // dayIsSelected(day) {
        //     if (!this.selectionStart || day < this.selectionStart) return false;
        //     return !(!this.selectionEnd || day > this.selectionEnd);
        // },
        getWeekEvents(weekStart) {
            // Return a list of events that CONTAIN the week starting on a day.
            // Sorted so the events that start earlier are always shown first.
            const events = this.findAndSortEventsInWeek(weekStart.startOf("day"));
            const results = [];
            const eventRows = [[], [], [], [], [], [], []];
            for (let i = 0; i < events.length; i++) {
                const ep = Object.assign({}, events[i], {
                    classes: events[i].classes ? [...events[i].classes] : [],
                    eventRow: 0,
                });
                //* change for endTime
                // const continued = ep.start_date.isBefore(weekStart);
                const continued = false;
                const startOffset = continued ? 0 : this.diff(ep.start_date, weekStart);

                //* change for endTime
                // const spanContinued = continued ? this.diff(moment(ep.end_date), weekStart) + 1 : this.diff(moment(ep.end_date), ep.start_date) + 1;
                const spanContinued = false;
                const span = Math.min(7 - startOffset, spanContinued);

                if (continued) ep.classes.push("continued");
                //*change for end_date
                if(Object.hasOwn(ep, 'end_date')){
                    //*change for endTime
                    // if (this.diff(ep.end_date, weekStart) > 6)
                    //     ep.classes.push("toBeContinued");
                    //*change for endTime
                    // if (ep.end_date.isBefore(moment())) ep.classes.push("past");
                    if (ep.end_date.isBefore(moment())) ep.classes.push("oneDay");
                    if (ep.end_date.isBetween(moment(ep.start_date), moment(ep.start_date).endOf("day"), undefined, "[]"))
                        ep.classes.push("oneDay");
                }else
                    ep.classes.push("oneDay");

                for (let d = 0; d < 7; d++) {
                    if (d === startOffset) {
                        let s = 0;
                        while (eventRows[d][s]) s++;
                        ep.eventRow = s;
                        eventRows[d][s] = true;
                    } else if (d < startOffset + span) {
                        eventRows[d][ep.eventRow] = true;
                    }
                }
                ep.classes.push(`offset${startOffset}`);
                //*change for end_date
                // ep.classes.push(`span${span}`);
                ep.classes.push('span1')
                results.push(ep);
            }
            return results;
        },
        getEventTop(e) {
            // Compute the top position of the event based on its assigned row within the given week.
            const r = e.eventRow;
            const h = this.isWeekPeriod ? "2.9em" : "1.3em";
            const b = this.isWeekPeriod ? "5px" : "3px";
            return `calc( ${this.isWeekPeriod ? "3.4em" : "2.5em"} + ${r}*${h} + ${r}*${b})`;
        },
        diff(e, s) {
            const add_diff = s.clone().startOf("day").add(e.diff(s, "m"), "m"),
                diff = e.diff(s, "day");

            if (add_diff.isBefore(e, "day")) return diff + 1;
            return diff;
            //const diff = e.diff(s, 'day')
            //if (parseInt(e.format('jD')) > parseInt(s.format('jD'))) return parseInt(e.format('jD')) - parseInt(s.format('jD'))
        },
        emitDay(day, $event) {
            if (this.disablePastDays) {
                if (!day.isBefore(moment(), "day")) {
                    this.$emit("on-day-click", day);
                } else {
                    $event.stopPropagation();
                }
            }
        },
    },
};
</script>
<style lang="scss">
/** Extra small devices (phones, 600px and down) */
$xs: "screen and (max-width: 600px)";
/** Small devices (portrait tablets and large phones, 601px to 768px) */
$sm: 'screen and (min-width: 601px) and (max-width: 768px)';
/** Medium devices (landscape tablets, 769px to 991px) */
$md: 'screen and (min-width: 769px) and (max-width: 991px)';
/** Large devices (laptops/desktops, 992px to 1200px) */
$lg: 'screen and (min-width: 992px) and (max-width: 1200px)';
/** Extra large devices (large laptops and desktops, 1201px and up) */
$xl: 'screen and (min-width: 1201px)';
// The mdia mixin
@mixin media( $selectors... ) {
  $selector: '';
  @each $s in $selectors {
    @if $selector == '' {
      $selector: $s;
    } @else {
      $selector: $selector + ', ' + $s;
    }
  }
  @media #{unquote($selector)}{
    @content;
  }
}

$primary_color: #0D3B66;
$background: #fff;
$past_background: rgb(250, 250, 250);
$not_current_month_background: $background;
$days_header_color: #626262;

$event_green: #42b983;
$event_black: #262626;

$border_color: #ddd;
$calendar_border: 1px solid $border_color;

@mixin calendar-row {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  /* Shorthand flex: 1 1 0 not supported by IE11 */
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0;
  flex-flow: row nowrap;
  border-width: 0;
  /* Allow week items to scroll if they are too tall */
  position: relative;
  overflow-y: auto;
  -ms-overflow-style: none;
}

@mixin calendar-cell {
  width: 100%;
  overflow: hidden;
  padding: 0.5em;
  border-right: $calendar_border;
  border-top: $calendar_border;
  user-select: none;
  background: $background;
}

@mixin shadow-text {
  background-color: #565656;
  color: transparent;
  text-shadow: 0px 1px 1px rgba(255, 255, 255, 0.5);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
}

@mixin text-center {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1em;
}

textarea{
  scrollbar-width: thin !important;
}

#persian-calendar {
  font-weight: normal;
  font-size: 1em;
  direction: rtl;
  user-select: none;


  * {
    padding: 0;
    margin: 0;
    box-sizing: content-box;
    -moz-box-sizing: content-box;
    -webkit-box-sizing: content-box;
    outline: none;
    text-transform: none;
    text-decoration: none;
  }

  #vpc_header {
    padding: 20px 15px;
    display: flex;

    #vpc_date-control {
      display: flex;
      justify-content: flex-start;
      font-size: 1em;

      .vpc_control-btn {
        width: 1em;
        height: 1em;
        padding: 0.3em;
        border-radius: 9999px !important;
        cursor: pointer !important;
        background-color: $primary_color !important;
        color: #fff !important;

        &[disabled] {
          background-color: #ccc !important;
          cursor: not-allowed !important;
        }
      }

      .vpc_now-date {
        margin: auto .75em;
        white-space: nowrap;
      }

      .vpc_today-btn {
        @include text-center;
        margin: 0 10px;
        height: 1.3em;
        line-height: 1em;
        vertical-align: middle;
        padding: 0.3em 2.2em;
        border-radius: 4px !important;
        font-size: 0.85rem;
        cursor: pointer !important;
        background-color: $primary_color !important;
        color: #fff !important;

        &[disabled] {
          background-color: #ccc !important;
          cursor: not-allowed !important;
        }
      }
    }

    .vpc_period-control {
      margin-right: auto;

      .vpc_period-btn {
        @include text-center;
        margin-right: 10px;
        height: 1.3em;
        line-height: 1em;
        vertical-align: middle;
        padding: 0.3em 2.2em;
        border-radius: 4px !important;
        cursor: pointer !important;
        background-color: $primary_color !important;
        color: #fff !important;
      }
    }
  }

  #vpc_calendar {
    border-radius: 15px;
    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, .1);
    position: relative !important;

    #vpc_days-header {
      @include calendar-row;

      div {
        @include calendar-cell;
        color: $days_header_color;
        font-size: 0.9em;
        line-height: 0.6em;
        text-align: center;
        cursor: default;

        &:first-child {
          border-top-right-radius: 15px;
        }

        &:last-child {
          border-top-left-radius: 15px;
          border-left: $calendar_border;
        }
      }
    }


    .vpc_week {
      min-height: calc(100vh - 170px);
      border-radius: 0 0 15px 15px !important;

      @include calendar-row;
      -ms-overflow-style: none;
      scrollbar-width: none;

      &::-webkit-scrollbar {
        display: none;
      }

      &.vpc_month-period{
        min-height: unset !important;
        height: 200px !important;
        border-radius: unset !important;
        overflow-y: hidden !important;
        & .vpc_event{
          height: 1.5em !important;
          &.oneDay:hover{
            transform: unset !important;
            background-color: #f6f6f6 !important;
            box-shadow: 0 0 1px #00000050 !important;
          }
          &-inner{
            color: black !important;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            &>div{
              &:first-child{
                margin-right: 0 !important;
                margin-top: -2px !important;
              }
              flex: 0 auto;
              width: auto;
              margin-right: 4px !important;
              font-size: 12px !important;
              @media only screen and (max-width: 900px){
                font-size: 11px !important;
              }
              &:last-child{
                margin-right: 4px !important;
                flex-basis: 0;
                flex-grow: 1;
                max-width: 100%;
              }
            }
          }
        }
      }

      .vpc_day {
        @include calendar-cell;
        padding: 0.2em 0.2em 0.15em 0.2em !important;
        // min-height: 120px;
        cursor: default;

        &.vpc_past {
          background-color: transparent;
          // &::before{
          //   background-color: #fafafa !important;
          // }
          // background-color: transparent;

          .vpc_day-number {
            @include shadow-text;
          }
        }

        &.vpc_not-current-month {
          background-color: $not_current_month_background;

          .vpc_day-number {
            @include shadow-text;
          }
        }

        &.vpc_week-period-day {
          height: 27px;
          position: sticky;
          top: 0;
          background-color: #fafafa;
          z-index: 15;

          .vpc_day-number {
            font-size: 1.4em;
            text-align: center;
            width: auto !important;
            z-index: 12;
            position: relative;
          }
        }

        &.vpc_today {
          .vpc_day-number {
            line-height: 1.3em;
            width: 1.3em;
            height: 1.2em;
            padding: 0;
            margin-top: 0;
            margin-right: 0;
            border-radius: 9999px !important;
            background-color: $primary_color !important;
            color: #fff !important;
            text-align: center;
          }
        }

        &.vpc_day-disable {
          background-color: $not_current_month_background !important;
        }

        .vpc_day-number {
          font-weight: bold;
          line-height: 1.2em;
        }

        &:last-child {
          border-left: $calendar_border;
        }
      }

      /* Events */
      .vpc_event {
        @include text-center;
        font-size: 0.8em;
        border-color: #e0e0f0;
        border-radius: 0.5em;
        text-overflow: ellipsis;
        position: absolute;
        white-space: nowrap;
        overflow: hidden;
        background-color: transparent;
        color: #fff;
        user-select: none;

        &-inner{
          height: 100%;
          padding: 2px 4px 0 4px;
        }

        &.offset0 {
          right: 0.38em;
        }

        $i: 1;
        @while $i <= 7 {
          &.span#{$i} {
            text-align: center;
            width: calc((#{$i+'00%'} / 7) - 0.75em);
          }
          &.offset#{$i} {
            right: calc((#{$i+'00%'} / 7) + 0.38em);
          }
          $i: $i+1;
        }

        &.isHovered {
          filter: brightness(95%);
        }

        &.continued {
          border-right-style: none;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;

          &:not(.toBeContinued) {
            .vpc_event-end-time {
              display: block;
            }
          }

          &.span1 {
            .vpc_event-start-date {
              display: none;
            }
          }

          .vpc_event-start-date {
            display: block;
          }
        }

        &.toBeContinued {
          border-left-style: none;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;

          &:not(.continued) {
            .vpc_event-start-time {
              display: block;
            }
          }

          &.span1 {
            .vpc_event-end-date {
              display: none;
            }
          }

          .vpc_event-end-date {
            display: block;
          }
        }

        &.continued::before,
        &.toBeContinued::after {
          content: " \21e0 ";
          padding: 0 0.1em;
        }

        &:not(.continued):not(.toBeContinued) {
          .vpc_event-start-time,
          .vpc_event-end-time {
            display: block;
          }
        }

        &.oneDay {
          // background-color: unset !important;
          color: white !important;
          transition: all 0.1s;
          &:hover{
            box-shadow: 0 0 10px #00000030;
            transform: scale(1.035);
          }

          .vpc_event-title {
            justify-content: inherit;
            margin: 0 0 0 0 !important;
            padding-top: 0 !important;
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
          }

          .vpc_event-ball {
            width: 9px;
            height: 9px;
            margin: 0 0.1em;
            border-radius: 999px;
          }

          .vpc_event-end-time {
            display: none !important;
          }
        }

        .vpc_event-title {
          text-overflow: ellipsis;
          overflow: hidden;
          margin: 0 auto;
        }

        .vpc_event-start-time,
        .vpc_event-start-time span,
        .vpc_event-end-time,
        .vpc_event-start-date,
        .vpc_event-end-date {
          margin: 0 0.2em;
          display: none;
        }


        /* Event Times */

        & .startTime,
        & .endTime {
          font-weight: bold;
          color: #666;
        }
      }

      &.vpc_week-period {
        .vpc_event {
          height: 1.4em;
          z-index: 3;

          &.oneDay {
            display: block;
            height: 2.85em;
            line-height: 1.25em;

            .vpc_event-ball {
              position: absolute;
              top: 0.1em;
            }
            .vpc_event-start-time span {
              display: contents;
            }
            .vpc_event-title {
              margin: 0.5em 0.8em;
              padding: 4px 0;
            }
          }
        }
      }

      &:last-child {
        .vpc_day {
          border-bottom: $calendar_border;
        }
      }
    }
  }

  .slide-left-enter-active, .slide-right-enter-active {
    transition: all .2s ease;
  }

  .slide-left-leave-active, .slide-right-leave-active {
    transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-left-enter, .slide-right-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  .slide-left-leave-to, .slide-right-enter {
    transform: translateX(-10px);
    opacity: 0;
  }

}
</style>
